var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.permissoes,"label":_vm.i18n(_vm.label),"outlined":_vm.outlined,"readonly":_vm.readonly,"clearable":_vm.clearable,"autofocus":_vm.autofocus,"prepend-inner-icon":_vm.icon,"hide-details":_vm.hideDetails},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}})
}
var staticRenderFns = []

export { render, staticRenderFns }